// Port of api/fuel/app/classes/filter/package/games/game/data/context.php
function hasPlayContext(filter) {
	return !!(
		(filter.played && filter.played.range && (filter.played.range.from || filter.played.range.to)) ||
		(filter.play && filter.play.count && (filter.play.count.from !== 1 || filter.play.count.to !== 10)) ||
		(filter.play && filter.play.duration && (filter.play.duration.from !== 0 || filter.play.duration.to !== 360)) ||
		(filter.play && filter.play.locations && filter.play.locations.length) ||
		(filter.play && filter.play.nolocation) ||
		(filter.play && filter.play.players && filter.play.players.required && filter.play.players.required.length)
	)
}

export default {
	priority: 1000,
	run: function(filter, data, config, global) {
		if (!hasPlayContext(filter)) return
		global.context = global.context || {}
		global.context.plays = {
			data: {},
			from: filter.played && filter.played.range ? filter.played.range.from : false,
			to: filter.played && filter.played.range ? filter.played.range.to : false
		}
	}
}
